
import { DataLayerManager } from '@agm/core';
import { Component, ComponentFactoryResolver, OnInit, ViewContainerRef } from '@angular/core';
import { ViewChild, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent, ColumnMode } from "@swimlane/ngx-datatable";
import { ApiService } from 'app/shared/services/api.service';
import { SessionStorageService } from 'app/shared/services/session-storage.service';
import { environment } from 'environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import swal from 'sweetalert2';
import { DynamicDetailComponent } from '../../dynamic-detail/dynamic-detail.component';



@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss',
    "../../../../../../assets/sass/libs/datatables.scss",],
  encapsulation: ViewEncapsulation.None,
})
export class ListComponent implements OnInit {
  @ViewChild(DatatableComponent) table: DatatableComponent;
  searchByName: ''
  searchVal = null
  page = {
    pageNumber: 0,
    offset: 0,
    pageSize: 100,
    totalPages: 0
  };
  // row data
  public rows = [];
  public filterRows = [];
  public ColumnMode = ColumnMode;
  public limitRef = 100;
  selectedValue = ''
  isFilter: boolean = false
  // column header
  public columns = [
    { name: " Name", prop: "name" },
    { name: "Email", prop: "email" },
    { name: "Designation", prop: "designation" },
    { name: "Phone", prop: "phone" },
    { name: "Actions", prop: "actions" },
  ];

  // private
  private tempData = [];
  imageUrl = environment.apiUrls.imageUrl;
  user_role: any
  statusList = []
  activeTab =''
  employee_id:any
  isActivated:boolean
  emp_typeList=[];
  typeId=  "6344000d91f6bc691e775faf" 
  @ViewChild('name') inputName;
  selected_type=null
  user_id:any
  total_salary:any
  employee_type: any
  employee_type_id =''
  public empTypeView: boolean[] = [];
  fileData:File;
  isCollapsed :boolean = false
  guideline_data:any

  referral_model ={
    refrence: '',
    report_to: '',
    notes: '',
    admin_notes: '',
  }
  emp_list =[]
  row_name :any
  user_idd:any
  form_data = new FormData()
  isRefral:any= true

 
  constructor(public apiService: ApiService,
    public toastr: ToastrService,
    private modalService: NgbModal,
    private session: SessionStorageService,
    private spinner: NgxSpinnerService,private activerouter: ActivatedRoute,
    private route: Router) {
    
    this.user_role = JSON.parse(localStorage.getItem('user'))
    let setting_data = JSON.parse(localStorage.getItem('setting-record'))
    let key_data = setting_data.filter((item) => item.key == 'Employee Guidelines')
    this.guideline_data = key_data[0]?._id

    this.activerouter.queryParams
    .subscribe((params: any) => {
      this.activeTab = params['status'];
    })

    this.getEmployeeStatusList()

    if(this.activeTab) this.activeEmployeeTab(this.activeTab)
    if(!this.activeTab) this.activeEmployeeTab('full_time')

  }

  ngOnInit(): void {
    this.getEmployeeType()
    this.getFullAndPartTimeEmp()
  }
  
  getEmployeeType(){
    this.apiService.getTagByTagCatgoryId(this.typeId).subscribe((res:any)=>{
      this.emp_typeList=res.data
    })
  }
  getTypeId(id,name){
    this.employee_type = name
    this.employee_type_id=id
    if(id !==''){
      let status = this.statusList.find((item) => item.name == this.activeTab);
      this.apiService.getEmployeeGroupingByTypeId(id,status?._id).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.rows=res?.items?.items
          this.page.totalPages= res?.items?.totalEmployee
        }
      })
    }  
  }
  activeEmployeeTab(tab) {
    const activetab = tab;
    this.activeTab = tab
    if (activetab !== '') {
      this.route.navigate(
        [],
        { relativeTo: this.activerouter, queryParams: { status: activetab } }
      );
    }
  }
  setAndGetEmployeebyStatus() {
    this.activerouter.queryParams
      .subscribe((params: any) => {
        this.activeTab = params?.status;
        this.getEmployeeList()
      })
  }
  getEmployeeStatusList() {
    this.apiService.getLeadsStatusList("employeestatus").subscribe((res: any) => {
      this.statusList = res.data
      const desiredStatusOrder = ['full_time', 'part_time', 'exemployee'];
      this.statusList.sort((a,b) => {
        const aIndex = desiredStatusOrder.indexOf(a.name)
        const bIndex = desiredStatusOrder.indexOf(b.name)
        return aIndex - bIndex
      })
      this.setAndGetEmployeebyStatus()
    })
  }
  getEmployeeList() {
      this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
      let status = this.statusList.find((item) => item.name == this.activeTab);
      this.apiService.getEmployeeListGroupingByStatus(status._id).subscribe((res: any) => {
      this.spinner.hide();
      this.rows = res?.data?.items
      this.page.totalPages = res?.data?.totalEmployee
      this.total_salary =res?.data?.totalsalary
    })
  }
  pageChangeData(page: any) {
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
      let status = this.statusList.find((item) => item.name == this.activeTab);
      this.apiService.getEmployeeListByStatus(status._id,this.page.pageNumber + 1, this.limitRef).subscribe((res: any) => {
      this.rows = res.items
      this.page.totalPages = res.items.total
    })
  }
  getEmployeeSearch(data: any) {
    this.searchVal = data
    if (this.searchVal) {
      this.apiService.getEmployeeSearchGrouping(this.searchVal,this.employee_type_id).subscribe((res: any) => {
        if(res.statusCode === 200){
          this.rows = res?.data?.items 
          this.page.totalPages = res.data.totalEmployee      
        }
      })
    }
    else {
      this.setAndGetEmployeebyStatus()
    }
  }
  resetFilter(){
    this.inputName.nativeElement.value = null;
    this.employee_type_id = ''
    this.employee_type =''
    this.setAndGetEmployeebyStatus()
  }
  setDefaultPassword(id: any, name: string) {
    if (id) {
      this.apiService.changePasswordEnrolment(id).subscribe((res: any) => {
        if (res.isSuccess === true) {
          this.toastr.success(res.message)
          swal.fire({
            title: "Success!",
            text: `${name} your password is combination of name's first 4 letters (capital) and phone number's last 4 digits`,
            icon: "success",
            customClass: {
              confirmButton: 'btn btn-primary'
            },
            buttonsStyling: false,
          });
        }
        else {
          this.toastr.error(res.error)
        }
      })
    }
  }
  copyToClipboard(name: any, phone: any) {
    let n = name.substring(0, 4).toUpperCase();
    let p = phone.substring(6)
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = n + p
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.toastr.info('Password copied')
  }

  deleteEmployee(password) {
    this.apiService.deleteEmployee(this.employee_id,password).subscribe((res: any) => {
      if(res.statusCode === 200){
        swal.fire({
          icon: "success",
          title: 'Deleted!',
          text: 'Your file has been deleted.',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
        this.setAndGetEmployeebyStatus()
      }
      else {
        swal.fire({
          icon: "error",
          title: 'Error!',
          text: `${res.error}`,
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    })
  }

  // ================== Delete Alert ========================
   Delete(id: any) {
    this.employee_id = id
    swal.fire({
      text: "Please Enter Password",
      input: 'password',
      showCancelButton: true,
    }).then((result) => {
      if (result.value) {
        this.deleteEmployee(result.value)

      } else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          text: 'Your file is safe :)',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });
  }

  updateEmpRole(id, status_id){

    let body={
      status:status_id
    }
   if(id){
    this.apiService.updateEmployee(id,body).subscribe((res:any)=>{
      if(res.statusCode === 200){
        this.toastr.success('Employee status update successfully')
        this.setAndGetEmployeebyStatus()
      }
      else{
        this.toastr.error(res.error)
      }
    })
   }
  }
  activateStudent(data){
    var id=data?.user?._id
    this.isActivated = data.user?.is_activated;
    let model = {
      is_activated: this.isActivated ? false : true
    };
    this.apiService.updateEmployee(id,model).subscribe((res: any) => {
      if (res.isSuccess === true) {
        this.toastr.success(res.message)
        this.setAndGetEmployeebyStatus()
      }
      else{
        this.toastr.error(res.error)
      }
    }) 
  }
  openModal(content, user_id, empTypes) {
    this.selected_type = empTypes._id
    this.user_id=user_id
    const modalRef = this.modalService.open(content);
   
    modalRef.result.then((result) => {
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }
  submit(){
    let body={
      employeetype : this.selected_type
    }
    this.apiService.updateEmployee(this.user_id,body).subscribe((res:any)=>{
      if(res.statusCode === 200){
        this.toastr.success('Employee type update successfully')
        this.setAndGetEmployeebyStatus()
        this.modalService.dismissAll()
      }
      else{
        this.toastr.error(res.error)
      }
    })
  }
  onSelectFile(event:any){
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      this.fileData = event.target.files[0];
      reader.readAsDataURL(event.target.files[0]);
      if(this.fileData){
        this.uploadCSVFile()
      }
    }
  }
  uploadCSVFile(){
    let formData=new FormData();
    formData.append('image',this.fileData)
    this.apiService.addEmployeeFromCSV(formData).subscribe((res:any)=>{
      if(res.statusCode === 200){
        this.toastr.success('csv file upload successfully!')
        this.setAndGetEmployeebyStatus()
      }
      else{
        this.toastr.error(res.error)
      }
    })
  }
  toggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
  }
 
  openDynamicModal(key_id:string) {
    const modalOptions: NgbModalOptions = {
      size: 'lg', // 'sm', 'lg', or 'xl'
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(DynamicDetailComponent,modalOptions);
    modalRef.componentInstance.key_id = key_id;
  }
  getFullAndPartTimeEmp(){
    this.apiService.getFullPartEmployeeList(1,100).subscribe((res:any)=>{
      this.emp_list = res?.items
    })
  }
  getEmpId(event){
    this.referral_model.report_to 
  }
  openModalForReferral(content,userId,name) {
    this.row_name = name
    this.referral_model.refrence = `${this.user_role.id}`
    this.user_idd = userId   

    const options: NgbModalOptions = {
      size: 'md', // set the size of the modal
      backdrop: 'static', // set whether clicking outside the modal closes it
      centered: true // set whether the modal is centered vertically
    };
    
    const modalRef = this.modalService.open(content,options);

    modalRef.result.then((result) => {
      this.referral_model.report_to = null
      this.referral_model.refrence = null
      this.user_idd = null
      this.form_data = new FormData()
    }, (reason) => {
      this.referral_model.report_to = null
      this.referral_model.refrence = null
      this.user_idd = null
      this.form_data = new FormData()
    });
   
  }
  addReferral(){
    this.form_data.append('ref_status','referal')
    this.form_data.append('report_to',this.referral_model?.report_to )
    this.form_data.append('notes',this.referral_model?.notes)
    this.form_data.append('admin_notes',this.referral_model?.admin_notes)
    this.form_data.append('is_refral',this.isRefral)
    this.form_data.append('refrence_by',this.user_role.id)
   
    this.apiService.updateUser(this.user_idd ,this.form_data).subscribe((res:any)=>{
      if(res?.statusCode === 200){
        this.toastr.success(res?.message)
        this.modalService.dismissAll()
        this.setAndGetEmployeebyStatus()
      }
      else this.toastr.error(res?.error)
    })
  }
}

